export enum AccessoryType {
	CABLE = 'CABLE',
	RFID = 'RFID',
	MID_THREE_PHASE = 'MID_THREE_PHASE',
	MID_MONO_PHASE = 'MID_MONO_PHASE',
	DPM_THREE_PHASE = 'DPM_THREE_PHASE',
	DPM_MONO_PHASE = 'DPM_MONO_PHASE',
	POLE = 'POLE',
}
